export default "__VITE_ASSET__CnOWaAKu__"